
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * LegalDocumentGroupGetFilterParams struct
 */
class LegalDocumentGroupGetFilterParams {
  /**
   * Initialize struct
   * @param {number=} groupId
   * @param {boolean=} includeDisabled
   * @constructor
   */
  constructor (groupId = null, includeDisabled = null) {
    this.GroupId = groupId
    this.IncludeDisabled = includeDisabled
  }

  /**
   * Copy struct (shallow copy)
   * @this {!LegalDocumentGroupGetFilterParams}
   * @param {!LegalDocumentGroupGetFilterParams} other Other struct
   * @returns {!LegalDocumentGroupGetFilterParams} This struct
   */
  copy (other) {
    if (other.GroupId != null) {
      this.GroupId = UInt64.fromNumber(other.GroupId)
    } else {
      this.GroupId = null
    }
    if (other.IncludeDisabled != null) {
      this.IncludeDisabled = other.IncludeDisabled
    } else {
      this.IncludeDisabled = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!LegalDocumentGroupGetFilterParams}
   * @returns {!LegalDocumentGroupGetFilterParams} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new LegalDocumentGroupGetFilterParamsModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new LegalDocumentGroupGetFilterParamsModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!LegalDocumentGroupGetFilterParams}
   * @param {!LegalDocumentGroupGetFilterParams} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof LegalDocumentGroupGetFilterParams)) {
      throw new TypeError('Instance of LegalDocumentGroupGetFilterParams is required!')
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!LegalDocumentGroupGetFilterParams}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    return {
      GroupId: ((this.GroupId != null) ? this.GroupId.toNumber() : null),
      IncludeDisabled: ((this.IncludeDisabled != null) ? this.IncludeDisabled : null)
    }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return LegalDocumentGroupGetFilterParams.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!LegalDocumentGroupGetFilterParams} other Object value
   * @returns {!LegalDocumentGroupGetFilterParams} Created struct
   */
  static fromObject (other) {
    return new LegalDocumentGroupGetFilterParams().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!LegalDocumentGroupGetFilterParams}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return LegalDocumentGroupGetFilterParams.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!LegalDocumentGroupGetFilterParams}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 15005
  }
}

export { LegalDocumentGroupGetFilterParams };

/**
 * Fast Binary Encoding LegalDocumentGroupGetFilterParams field model
 */
class FieldModelLegalDocumentGroupGetFilterParams extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this.GroupId = new fbe.FieldModelOptional(new fbe.FieldModelUInt64(buffer, 4 + 4), buffer, 4 + 4)
    this.IncludeDisabled = new fbe.FieldModelOptional(new fbe.FieldModelBool(buffer, this.GroupId.fbeOffset + this.GroupId.fbeSize), buffer, this.GroupId.fbeOffset + this.GroupId.fbeSize)
  }

  /**
   * Get the field size
   * @this {!FieldModelLegalDocumentGroupGetFilterParams}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelLegalDocumentGroupGetFilterParams}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.GroupId.fbeSize + this.IncludeDisabled.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelLegalDocumentGroupGetFilterParams}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.GroupId.fbeExtra + this.IncludeDisabled.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelLegalDocumentGroupGetFilterParams}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelLegalDocumentGroupGetFilterParams.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelLegalDocumentGroupGetFilterParams}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 15005
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelLegalDocumentGroupGetFilterParams}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelLegalDocumentGroupGetFilterParams}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.GroupId.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.GroupId.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.GroupId.fbeSize

    if ((fbeCurrentSize + this.IncludeDisabled.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.IncludeDisabled.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.IncludeDisabled.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelLegalDocumentGroupGetFilterParams}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelLegalDocumentGroupGetFilterParams}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelLegalDocumentGroupGetFilterParams}
   * @param {!LegalDocumentGroupGetFilterParams} fbeValue Default value, defaults is new LegalDocumentGroupGetFilterParams()
   * @returns {!LegalDocumentGroupGetFilterParams} LegalDocumentGroupGetFilterParams value
   */
  get (fbeValue = new LegalDocumentGroupGetFilterParams()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelLegalDocumentGroupGetFilterParams}
   * @param {!LegalDocumentGroupGetFilterParams} fbeValue LegalDocumentGroupGetFilterParams value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.GroupId.fbeSize) <= fbeStructSize) {
      fbeValue.GroupId = this.GroupId.get()
    } else {
      fbeValue.GroupId = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.GroupId.fbeSize

    if ((fbeCurrentSize + this.IncludeDisabled.fbeSize) <= fbeStructSize) {
      fbeValue.IncludeDisabled = this.IncludeDisabled.get()
    } else {
      fbeValue.IncludeDisabled = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.IncludeDisabled.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelLegalDocumentGroupGetFilterParams}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelLegalDocumentGroupGetFilterParams}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelLegalDocumentGroupGetFilterParams}
   * @param {!LegalDocumentGroupGetFilterParams} fbeValue LegalDocumentGroupGetFilterParams value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelLegalDocumentGroupGetFilterParams}
   * @param {LegalDocumentGroupGetFilterParams} fbeValue LegalDocumentGroupGetFilterParams value
   */
  setFields (fbeValue) {
    this.GroupId.set(fbeValue.GroupId)
    this.IncludeDisabled.set(fbeValue.IncludeDisabled)
  }
}

export { FieldModelLegalDocumentGroupGetFilterParams };

/**
 * Fast Binary Encoding LegalDocumentGroupGetFilterParams model
 */
class LegalDocumentGroupGetFilterParamsModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelLegalDocumentGroupGetFilterParams(this.buffer, 4)
  }

  /**
   * Get the LegalDocumentGroupGetFilterParams model
   * @this {!LegalDocumentGroupGetFilterParamsModel}
   * @returns {!FieldModelLegalDocumentGroupGetFilterParams} model LegalDocumentGroupGetFilterParams model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!LegalDocumentGroupGetFilterParamsModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!LegalDocumentGroupGetFilterParamsModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return LegalDocumentGroupGetFilterParamsModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!LegalDocumentGroupGetFilterParamsModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelLegalDocumentGroupGetFilterParams.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!LegalDocumentGroupGetFilterParamsModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!LegalDocumentGroupGetFilterParamsModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!LegalDocumentGroupGetFilterParamsModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!LegalDocumentGroupGetFilterParamsModel}
   * @param {!LegalDocumentGroupGetFilterParams} value LegalDocumentGroupGetFilterParams value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!LegalDocumentGroupGetFilterParamsModel}
   * @param {!LegalDocumentGroupGetFilterParams} value LegalDocumentGroupGetFilterParams value, defaults is new LegalDocumentGroupGetFilterParams()
   * @return {!object} Deserialized LegalDocumentGroupGetFilterParams value and its size
   */
  deserialize (value = new LegalDocumentGroupGetFilterParams()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new LegalDocumentGroupGetFilterParams(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new LegalDocumentGroupGetFilterParams(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!LegalDocumentGroupGetFilterParamsModel}
   * @param {!number} prev Previous LegalDocumentGroupGetFilterParams model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { LegalDocumentGroupGetFilterParamsModel };
